// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    // init Swiper:
    document.querySelectorAll('.pagination-swiper, .v2-wpg-abo-review-items').forEach(swiperEl => {
        new Swiper(swiperEl, {
            modules: [Pagination, Navigation, A11y],
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 1.2,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 32,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            a11y: {
                paginationBulletMessage: 'Ga naar slide {{index}}',
            },
        });
    });

    const swiper_pagination = new Swiper('.pagination-swiper', {
        modules: [Pagination, Navigation, A11y],
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        a11y: {
            paginationBulletMessage: 'Ga naar slide {{index}}',
        },
    });

    const swiper_pagination_tiles = new Swiper('.pagination-swiper-tiles', {
        modules: [Pagination, Navigation, A11y],
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        a11y: {
            paginationBulletMessage: 'Ga naar slide {{index}}',
        },
    });

    const swiper_teacher = new Swiper('.teacher-swiper', {
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            }
        },
    });

    // YOGATV SLIDERS
    const cardSwiper = new Swiper('.card-slider-container', getCardSliderSettings());

    // slider for styles and teachers
    const styleteachSlider = new Swiper('.card-styleteacher-slider-container', {
        modules: [Navigation, A11y],
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 20,
        slidesPerView: 2.6,
        freeMode: true,
        freeModeMomentumRatio: 0.7,
        freeModeMomentumVelocityRatio: 0.7,
        breakpoints: {
            992: {
                slidesPerView: 6,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3.9,
                spaceBetween: 30,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        a11y: {
            prevSlideMessage: 'Ga naar vorige slide',
            nextSlideMessage: 'Ga naar volgende slide',
        },
    });

    // Init Blueconic card sliders 
    document.addEventListener("init-bc-card-slider", () => {
        const bcCardSwiper = new Swiper('.bc-card-slider-container', getCardSliderSettings());
    });

    document.addEventListener("init-onboarding-slider", () => {
        const bcCardSwiper = new Swiper('.onboarding-slider-container', getCardSliderSettings());
    });
});

function getCardSliderSettings() {
    let settings = {
        modules: [Navigation, A11y],
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.3,
        freeMode: true,
        freeModeMomentumRatio: 0.7,
        freeModeMomentumVelocityRatio: 0.7,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        a11y: {
            prevSlideMessage: 'Ga naar vorige slide',
            nextSlideMessage: 'Ga naar volgende slide',
        },
    };

    return settings;
}

